import React from "react";
import './HomePage.css';

import {IconButton, Paper} from "@mui/material";
import {ArrowBackIosNew, ArrowForwardIos} from "@mui/icons-material";

// Banners
import brooks_large from "../../images/banners/4titude/Bandeau-4titude-1160x330.jpg";
import brooks_medium from "../../images/banners/4titude/Bandeau-4titude-770x330.jpg";
import brooks_small from "../../images/banners/4titude/Bandeau-4titude-375x330.jpg";
import bioline_large from "../../images/banners/bioline/Bandeau-Bioline-1160x330.jpg";
import bioline_medium from "../../images/banners/bioline/Bandeau-Bioline-770x330.jpg";
import bioline_small from "../../images/banners/bioline/Bandeau-Bioline-375x330.jpg";
import biosan_large from "../../images/banners/biosan/Bandeau-Biosan-1160x330.jpg";
import biosan_medium from "../../images/banners/biosan/Bandeau-Biosan-770x330.jpg";
import biosan_small from "../../images/banners/biosan/Bandeau-Biosan-375x330.jpg";
import seval_large from "../../images/banners/seval/Bandeau-Verrerie-1160x330.jpg";
import seval_medium from "../../images/banners/seval/Bandeau-Verrerie-770x330.jpg";
import seval_small from "../../images/banners/seval/Bandeau-Verrerie-375x330.jpg";

// Brochures
import biosan_brochure_image from "../../images/catalogues/2021/biosan/biosan_2021_05.png";
import biosan_brochure_pdf from "../../images/catalogues/2021/biosan/biosan_2021.pdf";
import bioline_brochure_image from "../../images/catalogues/2021/bioline/bioline_2020.png";
import bioline_brochure_pdf from "../../images/catalogues/2021/bioline/bioline_2021.pdf";
import phcbi_brochure_image from "../../images/catalogues/2021/phcbi/phcbi_2021.png";
import phcbi_brochure_pdf from "../../images/catalogues/2021/phcbi/phcbi_2021.pdf";
import brooks_brochure_image from "../../images/catalogues/2021/brooks/brooks_2021.png";
import brooks_brochure_pdf from "../../images/catalogues/2021/brooks/brooks_2021.pdf";
import btx_brochure_pdf from "../../images/catalogues/2024/btx/btx.pdf";
import btx_brochure_image from "../../images/catalogues/2024/btx/btx.png";
import Azenta_brochure_pdf from "../../images/catalogues/2024/azenta/azenta.pdf";
import Azenta_brochure_image from "../../images/catalogues/2024/azenta/azenta.png";

import {ExposedAPI} from "../../apis/ExposedAPI";
import ArticleList from "../../components/article/articleList/ArticleList";
import Seo from "../../components/seo";
import {organizationJsonLd} from "../../utils/jsonld";

export default class HomePage extends React.Component{

    constructor(props) {
        super(props);

        let carouselImages = this.getCarouselImages();

        this.state={
            carouselImages:carouselImages,
            currentCarrouselImage:carouselImages[0],
            brochures:[],
            brochureSlideIndex:0,

            featuredArticles:[],
        }
    }

    componentDidMount(){
        this.startCarousel();
        this.startBrochureSlider();
        this.loadFeaturedArticles();
        this.loadHomeCatalogs();
    }

    componentWillUnmount(){
        this.stopCarousel()
        this.stopBrochureSlider()
    }

    componentDidUpdate(prevProps, prevState){
        if(prevState.brochures.length !== this.state.brochures.length){
            const visibleCount = Math.min(5, this.state.brochures.length);
            const maxSlideIndex = Math.max(0, this.state.brochures.length - visibleCount);
            if(this.state.brochureSlideIndex > maxSlideIndex){
                this.setState({brochureSlideIndex:0});
            }
            this.startBrochureSlider();
        }
    }

    loadFeaturedArticles(){

        ExposedAPI.getFeaturedArticles()
            .then((articles)=>{
                for(let article of articles){
                    if(article.description.length > 180){article.short_description = article.description.substring(0,180) + "..."}
                    else{article.short_description = article.description}

                    article.sort_name = article.label.toUpperCase();
                    article.sort_brand = article.brandName ? article.brandName.toUpperCase() : "";
                    article.sort_ref = article.crmId.toUpperCase();
                    article.sort_cond = article.conditionnement ? article.conditionnement.toUpperCase() : "";
                    article.sort_ht = parseFloat(article.basePrice);
                }
                this.setState({
                    featuredArticles:articles,
                })
            })
            .catch((err)=>{
                console.log(err)
            })

    }

    loadHomeCatalogs(){
        ExposedAPI.getHomeCatalogs()
            .then((catalogs)=>{
                this.setState({
                    brochures: (catalogs || []).map((catalog)=>{
                        return {
                            id: catalog.id,
                            label: catalog.label,
                            image: catalog.image_url,
                            pdf: catalog.pdf_url,
                        }
                    }),
                    brochureSlideIndex:0,
                })
            })
            .catch((err)=>{
                console.log(err)
            })
    }

    render(){
        return(
            <>
            <Seo
                title="Matériel et consommables de laboratoire | Bio-Technofix"
                description="Bio-Technofix fournit depuis 1993 du matériel, des consommables et des équipements pour les laboratoires de recherche, d'enseignement et d'industrie."
                path="/home"
                jsonLd={organizationJsonLd}
            />
            <div className={"home-page-wrapper"}>
                <h1 style={{position:"absolute", width:1, height:1, padding:0, margin:-1, overflow:"hidden", clip:"rect(0, 0, 0, 0)", whiteSpace:"nowrap", border:0}}>
                    Matériel et consommables de laboratoire
                </h1>
                {this.renderSimpleCarousel()}
                <div style={{height:25}}/>
                {this.renderBrochures()}
                <div style={{height:25}}/>
                {this.renderFeatured()}
            </div>
            </>
        )
    }

    //////////////
    // CAROUSEL //
    //////////////

    renderSimpleCarousel(){
        return(
            <div style={{height:330, width:"100%", backgroundColor:"#FAFAFA", position:"relative", borderBottomLeftRadius:6,
            borderBottomRightRadius:6, overflow:"hidden"}}>

                <div className={"carousel-image"} style={{backgroundImage:"url(" + this.state.currentCarrouselImage.image + ")"}}/>
                {this.state.currentCarrouselImage.link &&
                    <a rel={"noreferrer nofollow"} href={this.state.currentCarrouselImage.link}>
                        <div style={{width:"100%", height:330, position:"absolute", left:0, top:0, bottom:0, right:0}}>

                        </div>
                    </a>
                }

            </div>
        )
    }

    _carouselInteval;

    startCarousel(){
        if(this._carouselInteval){this.stopCarousel()}
        this._carouselInteval = setInterval(()=>{
            let nextIndex = this.state.currentCarrouselImage.id + 1;
            if(nextIndex > this.state.carouselImages.length - 1){
                nextIndex = 0
            }
            this.setState({
                currentCarrouselImage:this.state.carouselImages[nextIndex],
            })
        },10000)
    }

    stopCarousel(){
        if(this._carouselInteval){
            clearInterval(this._carouselInteval);
            this._carouselInteval = null;
        }
    }

    getCarouselImages(){
        return([
            {
                id:0,
                link:"https://www.brookslifesciences.com/",
                image:this.getImage(0),
            },
            {
                id:1,
                link:"https://www.bioline.com/",
                image:this.getImage(1),
            },
            {
                id:2,
                link:"https://www.biosan.lv/fr",
                image:this.getImage(2),
            },
            {
                id:3,
                link:null,
                image:this.getImage(3),
            }
        ])
    }

    getImage(id){
        switch(id){
            case 0:{
                if(window.innerWidth > 768){return brooks_large}
                else if(window.innerWidth > 375){return brooks_medium}
                else{return brooks_small}
            }
            case 1:{
                if(window.innerWidth > 768){return bioline_large}
                else if(window.innerWidth > 375){return bioline_medium}
                else{return bioline_small}
            }
            case 2:{
                if(window.innerWidth > 768){return biosan_large}
                else if(window.innerWidth > 375){return biosan_medium}
                else{return biosan_small}
            }
            case 3:{
                if(window.innerWidth > 768){return seval_large}
                else if(window.innerWidth > 375){return seval_medium}
                else{return seval_small}
            }
        }
    }

    ///////////////
    // BROCHURES //
    ///////////////

    getBrochures(){
        return([
            {
                id:0,
                label:"Catalogue Bio-Technofix",
                image:btx_brochure_image,
                pdf:btx_brochure_pdf,
            },
            {
                id:1,
                label:"Catalogue Azenta",
                image:Azenta_brochure_image,
                pdf:Azenta_brochure_pdf,
            },
            {
                id:2,
                label:"Catalogue Biosan",
                image:biosan_brochure_image,
                pdf:biosan_brochure_pdf,
            },
            {
                id:3,
                label:"Catalogue Bioline",
                image:bioline_brochure_image,
                pdf:bioline_brochure_pdf,
            },
            {
                id:4,
                label:"Catalogue PHCBi",
                image:phcbi_brochure_image,
                pdf:phcbi_brochure_pdf,
            },
            {
                id:5,
                label:"Catalogue Brooks",
                image:brooks_brochure_image,
                pdf:brooks_brochure_pdf,
            }
        ])
    }

    _brochureInterval;

    startBrochureSlider(){
        if(this._brochureInterval){this.stopBrochureSlider()}
        this._brochureInterval = setInterval(()=>{
            this.nextBrochureSlide();
        },5000)
    }

    stopBrochureSlider(){
        if(this._brochureInterval){
            clearInterval(this._brochureInterval);
            this._brochureInterval = null;
        }
    }

    getBrochureSliderConfig(){
        const total = this.state.brochures.length;
        const visible = Math.min(5, total);
        const maxIndex = Math.max(0, total - visible);
        return { total, visible, maxIndex };
    }

    nextBrochureSlide(){
        this.setState((prevState)=>{
            const visible = Math.min(5, prevState.brochures.length);
            const maxIndex = Math.max(0, prevState.brochures.length - visible);
            if(maxIndex === 0){return null}
            const nextIndex = prevState.brochureSlideIndex >= maxIndex ? 0 : prevState.brochureSlideIndex + 1;
            return { brochureSlideIndex: nextIndex };
        })
    }

    prevBrochureSlide(){
        this.setState((prevState)=>{
            const visible = Math.min(5, prevState.brochures.length);
            const maxIndex = Math.max(0, prevState.brochures.length - visible);
            if(maxIndex === 0){return null}
            const nextIndex = prevState.brochureSlideIndex <= 0 ? maxIndex : prevState.brochureSlideIndex - 1;
            return { brochureSlideIndex: nextIndex };
        })
    }

    renderBrochures(){
        const { total, visible } = this.getBrochureSliderConfig();
        const canSlide = total > visible;
        const cardWidthPercent = visible > 0 ? (100 / visible) : 100;

        return(
            <Paper style={{width:"100%", padding:12}}>
                <h2 style={{color:"#222222", fontSize:16, textAlign:"left", fontWeight:"bold", textTransform:"uppercase", margin:0}}>Nos catalogues</h2>
                <p style={{color:"#555555", fontSize:14, textAlign:"left",  margin:0, marginTop:8,marginBottom:8}}>
                    Découvrez nos catalogues contenant tous nos produits, et nos promotions en cours :
                </p>
                <div style={{position:"relative", width:"100%", paddingBottom:4, paddingTop:4}}>
                    <IconButton
                        size={"small"}
                        onClick={()=>this.prevBrochureSlide()}
                        style={{
                            position:"absolute",
                            left:4,
                            top:"50%",
                            transform:"translateY(-50%)",
                            zIndex:20,
                            backgroundColor:"rgba(255,255,255,0.95)",
                            border:"1px solid #E0E0E0",
                        }}
                        disabled={!canSlide}
                    >
                        <ArrowBackIosNew style={{fontSize:15}}/>
                    </IconButton>
                    <IconButton
                        size={"small"}
                        onClick={()=>this.nextBrochureSlide()}
                        style={{
                            position:"absolute",
                            right:4,
                            top:"50%",
                            transform:"translateY(-50%)",
                            zIndex:20,
                            backgroundColor:"rgba(255,255,255,0.95)",
                            border:"1px solid #E0E0E0",
                        }}
                        disabled={!canSlide}
                    >
                        <ArrowForwardIos style={{fontSize:15}}/>
                    </IconButton>
                    <div style={{width:"100%", overflow:"hidden"}}>
                        <div
                            style={{
                                width:"100%",
                                display:"flex",
                                flexDirection:"row",
                                transition:"transform 400ms ease",
                                transform:`translateX(-${this.state.brochureSlideIndex * cardWidthPercent}%)`,
                            }}
                        >
                            {this.state.brochures.map((brochure)=>{
                                return(
                                    <div
                                        key={"brochure_" + brochure.id}
                                        style={{
                                            flex:`0 0 ${cardWidthPercent}%`,
                                            minWidth:0,
                                            padding:"0 6px",
                                            boxSizing:"border-box",
                                        }}
                                    >
                                        <Paper style={{width:"100%", overflow:"hidden", position:"relative"}}>
                                          <a
                                            href={brochure.pdf}
                                            aria-label={`Ouvrir le catalogue ${brochure.label} au format PDF`}
                                            style={{display:"block", color:"inherit", textDecoration:"none"}}
                                          >
                                            <img style={{width:"100%", height:250, objectFit:"cover"}} alt={`Couverture du catalogue ${brochure.label}`} src={brochure.image}/>
                                            <div style={{width:"100%", height:40, display:"flex", flexDirection:"row", justifyContent:"flex-start", alignItems:"center",
                                            backgroundColor:"#FAFAFA", borderTop:"1px solid #EFEFEF"}}>
                                                <p style={{color:"#222222", fontSize:12, textAlign:"left", paddingLeft:12, margin:0}}>
                                                    {brochure.label}
                                                </p>
                                            </div>
                                          </a>
                                        </Paper>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </Paper>
        )
    }

    renderFeatured(){

        if(this.state.featuredArticles.length === 0){return null}
        return(
            <Paper style={{width:"100%", padding:12}}>
                <h2 style={{color:"#222222", fontSize:16, textAlign:"left", fontWeight:"bold", textTransform:"uppercase", margin:0}}>Produits à la Une</h2>
                <p style={{color:"#555555", fontSize:14, textAlign:"left",  margin:0, marginTop:8,marginBottom:8}}>
                    Découvrez notre sélection de produits mis en avant:
                </p>
                <Paper style={{width:"100%"}}>
                    <ArticleList
                        articles={this.state.featuredArticles}
                        virtualized={true}
                        listHeight={this.state.featuredArticles.length >= 6 ? 600 : this.state.featuredArticles.length*100}
                    />
                </Paper>
            </Paper>
        )
    }
}
